module.exports = __webpack_public_path__ + "mods/slumgud_-_low_freq_operator.mod";